import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { CarrierVisitPerformanceStoppagesDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { EmptyIndicator, useMinimalsTheme } from '@tom-ui/ui'
import { useDateFormat } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

type StoppagesCardProps = {
  stoppagesDetail?: CarrierVisitPerformanceStoppagesDto | null
}

export const StoppagesCard: FC<StoppagesCardProps> = observer(({ stoppagesDetail }) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()
  const { formatMinutesToHoursAndMinutes } = useDateFormat()

  return (
    <Paper sx={{ padding: theme.customSpacing.m, height: '100%' }}>
      <Typography
        variant='h6'
        paddingLeft={theme.customSpacing.m}
        marginBottom={theme.customSpacing.m}
      >
        {t('stoppages', 'Stoppages')}
      </Typography>
      <Stack direction='column'>
        <TableContainer component={Paper} elevation={0}>
          <Table size='small' aria-label='a dense table'>
            <TableHead>
              <TableRow
                sx={{
                  '& .MuiTableCell-head': {
                    backgroundColor: 'transparent',
                    borderBottom: `1px solid ${theme.palette.divider}`,
                  },
                }}
              >
                <TableCell>
                  <Typography variant='subtitle2'>{t('description', 'Description')}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='subtitle2'>{t('duration', 'Duration')}</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {stoppagesDetail?.stoppages.map(stoppage => (
                <TableRow
                  key={stoppage.name}
                  sx={{
                    '& .MuiTableCell-root': { borderBottom: `1px solid ${theme.palette.divider}` },
                  }}
                >
                  <TableCell component='th' scope='row'>
                    {t(stoppage?.name)}{' '}
                  </TableCell>
                  <TableCell>
                    {stoppage?.totalMinutes
                      ? formatMinutesToHoursAndMinutes(stoppage?.totalMinutes)
                      : EmptyIndicator}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow
                sx={{
                  '& .MuiTableCell-root': { borderBottom: `1px solid ${theme.palette.divider}` },
                }}
              >
                <TableCell align='right'>
                  <Typography variant='subtitle2'>{t('total', 'Total')}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant='subtitle2'>
                    {formatMinutesToHoursAndMinutes(stoppagesDetail?.totalMinutes ?? 0)}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Stack>
    </Paper>
  )
})
